import React, { useState, useEffect } from 'react';
import { Music, X } from 'lucide-react';

const CreatePlaylistDialog = ({ isOpen, onClose, onConfirm }) => {
  const [playlistName, setPlaylistName] = useState('');

  // 重置输入框
  useEffect(() => {
    if (isOpen) {
      setPlaylistName('');
    }
  }, [isOpen]);

  // 处理表单提交
  const handleSubmit = (e) => {
    e.preventDefault();
    if (playlistName.trim()) {
      onConfirm(playlistName.trim());
      onClose();
    }
  };

  // 处理键盘事件
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-dark-50 rounded-2xl shadow-2xl w-full max-w-md">
        {/* 头部 */}
        <div className="flex items-center justify-between p-6 border-b border-dark-200">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-violet-500 rounded-xl flex items-center justify-center">
              <Music size={20} className="text-white" />
            </div>
            <h3 className="text-lg font-semibold text-dark-800">创建歌单</h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-dark-100 rounded-lg transition-colors duration-200"
          >
            <X size={20} className="text-dark-600" />
          </button>
        </div>

        {/* 内容 */}
        <form onSubmit={handleSubmit}>
          <div className="p-6">
            <div className="mb-4">
              <label className="block text-sm font-medium text-dark-700 mb-2">
                歌单名称
              </label>
              <input
                type="text"
                value={playlistName}
                onChange={(e) => setPlaylistName(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="请输入歌单名称..."
                className="w-full px-4 py-3 bg-dark-100 border border-dark-200 rounded-xl text-dark-800 placeholder-dark-400 focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-400 transition-all duration-200"
                autoFocus
                maxLength={50}
              />
            </div>
            <p className="text-xs text-dark-500">
              歌单名称长度不能超过50个字符
            </p>
          </div>

          {/* 操作按钮 */}
          <div className="flex gap-3 p-6 pt-0">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-3 bg-dark-200 text-dark-700 rounded-xl font-medium hover:bg-dark-300 transition-colors duration-200"
            >
              取消
            </button>
            <button
              type="submit"
              disabled={!playlistName.trim()}
              className="flex-1 px-4 py-3 bg-primary-500 text-white rounded-xl font-medium hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
            >
              创建
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreatePlaylistDialog;
